import api from '../index'

let header = {
    belong: 'bulletin'
}

export default {
    getProductStatistic(params){
        
        return api.get('/product/data', params, header)
    },
    getArticleRank(params){
        return api.get('/article_data/rank', params,header)
    },
    getChannelStatistic(params){
        return api.get('/article_data/channel', params,header)
    }
}